import { combineReducers } from "redux";
import courseReducer from "./courseSlice";
import packageReducer from "./packageSlice";
import subjectReducer from "./subjectSlice";
import chapterReducer from "./chapterSlice";
import topicReducer from "./topicSlice";
import subtopicReducer from "./subtopicSlice";
import timetableReducer from "./timetableSlice";
import classScheduleReducer from "./classScheduleSlice";
import assignmentReducer from "./assignmentSlice";
import mentorAuthenticationReducer from "./authenticationSlice";
import lectureReducer from "./lectureSlice"
import pdfReducer from "./openPdfSlice";
import teacherManagementReducer from './teacherManagementSlice'
const reducerObj = {
  packages: packageReducer,
  courses: courseReducer,
  subject: subjectReducer,
  chapters: chapterReducer,
  topics: topicReducer,
  subtopics: subtopicReducer,
  timetables: timetableReducer,
  classes: classScheduleReducer,
  assignments: assignmentReducer,
  mentorAuthentications: mentorAuthenticationReducer,
  lecture:lectureReducer,
  pdfs:pdfReducer,
  teacherManagement:teacherManagementReducer
};

const rootReducer = combineReducers(reducerObj);

export default rootReducer;
